import { paths } from '@luxuryescapes/contract-svc-merchandise'
import requestUtils from 'api/requestUtils'
import qs from 'qs'

type Response = paths['/api/merchandise/shipping']['get']['responses']['200']['content']['application/json']

function getMerchandiseShipping(variantIds: Array<string>): Promise<Array<App.MerchandiseShipping>> {
  const query = qs.stringify({
    variantIds: variantIds,
  }, { arrayFormat: 'comma' })

  return requestUtils.get<Response>(`/api/merchandise/shipping?${query}`, { credentials: 'include' }).then(response => {
    return response.result.shippingBySeller.flatMap((seller) => {
      return seller.shippingByVariant.map((variant): App.MerchandiseShipping => ({
        id: seller.sellerId,
        variantId: variant.variantId,
        price: variant.shippingCost,
        sellerId: seller.sellerId,
      }))
    })
  })
}

export default getMerchandiseShipping
